import BoxLibrary from "@/appComponents/Navigation/RightSidebar/BoxLibrary/BoxLibrary";
import * as StateLib from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";
import { Flex, Text } from "@theorgchartdev/storybook";

const BoxStyleSection = props => {
  const wsMgr = StateLib.GetWSMgr();
  const bsMgr = wsMgr.GetBoxStylesMgr();
  const rule = props.rule;

  const SetBoxStyle = layout => {
    if (layout == null) return;
    const rule = props.rule.Clone();
    const layoutID = layout.GetBoxStyleID();
    rule.SetBoxStyleID(layoutID, props.actionType);
    props.setRule(rule);
  };

  const boxStyle = rule?.GetBoxStyleID(props.actionType);
  let boxStyleName = appstr("No box style selected");
  if (boxStyle) {
    boxStyleName = bsMgr.GetBoxStyleNameFromID(boxStyle);
  }

  return (
    <Flex height={"100%"} width={"100%"} overflow={"hidden"} direction={"column"}>
      <Flex gap={"4px"}>
        <Text size={"small"}>{appstr("Box selected")}:</Text>
        <Text modifier={"bold"} colorModifier={boxStyle ? "success" : "warning"} size={"small"}>
          {boxStyleName}
        </Text>
      </Flex>
      <Flex direction={"column"} width={"100%"} height={"100%"} overflow={"hidden"}>
        <BoxLibrary
          showTabs={true}
          showControls={false}
          onBoxSelect={SetBoxStyle}
          customWidth={props.customWidth}
          minWidth={props.minWidth}
          hierarchyType={props.hierarchyType}
        />
      </Flex>
    </Flex>
  );
};

export default BoxStyleSection;
